const cdnUrl = null
export default cdnUrl